import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskOrganizationV2Route: InvariantJiraRoute = {
	name: 'servicedesk-organization_v2',
	path: '/jira/servicedesk/projects/:projectKey/organization/:organizationId',
	exact: true,
};
